export enum SignupWorkflowVerificationType{
    SIMPLE = 0,
    ONLINE_APPOINTMENT_CLINIWEB = 1
}